import { useHistory, useLocation } from 'react-router';
import { getPreviousPage } from 'scenes/payments/routes';
import * as H from 'history';

const previousPage = (pathname: string, history: H.History) => {
  // Navigate to previous page
  const page = getPreviousPage(pathname);
  if (page) {
    history.push(page);
  }
};

export const usePreviousPage = () => {
  const location = useLocation();
  const history = useHistory();

  return () => previousPage(location.pathname, history);
};

export default usePreviousPage;
